// modules
import { createSelector } from 'reselect'
import { get, sortBy } from 'lodash'

// constants
import { OTHER_DROPDOWN_VALUE } from 'src/constants'

// utils
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

const medicalDeviceOrdering$ = (state) =>
  get(state, ['admin', 'medicalDeviceOrdering'], {})

export const medicalDeviceOrderingOrderList$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) => get(medicalDeviceOrdering, ['orderList'], [])
)

export const medicalDeviceOrderingEditOrder$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) => get(medicalDeviceOrdering, ['editOrder'], {})
)

export const medicalDeviceOrderingCompanyList$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) =>
    get(medicalDeviceOrdering, ['companyList'], [])
)

export const medicalDeviceOrderingCompanyListWithAll$ = createSelector(
  medicalDeviceOrderingCompanyList$,
  (medicalDeviceOrderingCompanyList = []) =>
    addAllValueV5({ list: medicalDeviceOrderingCompanyList })
)

export const medicalDeviceOrderingPatientAddresses$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) =>
    get(medicalDeviceOrdering, ['patientAddresses'], [])
)

export const medicalDeviceOrderingPatientAddressesDropdown$ = createSelector(
  medicalDeviceOrderingPatientAddresses$,
  (patientAddresses = []) => {
    const mappedAddresses = patientAddresses.map(
      ({ uuid, address, city, state, zip }) => ({
        key: uuid,
        value: uuid,
        title: `${address}, ${city}, ${state}, ${zip}`,
        address,
        state,
        city,
        zip
      })
    )

    mappedAddresses.push(OTHER_DROPDOWN_VALUE)

    return mappedAddresses
  }
)

export const medicalDeviceOrderingPatientProfile$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) =>
    get(medicalDeviceOrdering, ['patientProfile'], {})
)

export const medicalDeviceOrderingTypeList$ = createSelector(
  medicalDeviceOrdering$,
  (medicalDeviceOrdering = {}) => get(medicalDeviceOrdering, ['typeList'], {})
)

export const medicalDeviceOrderingTypeListDropdown$ = createSelector(
  medicalDeviceOrderingTypeList$,
  (typeList = []) =>
    sortBy(
      typeList.map((item) => ({
        key: item.uuid,
        title: item.name,
        value: item.uuid,
        isActive: item.isActive,
        disabled: !item.isActive,
        isIntegrationIdRequired: item.isIntegrationIdRequired
      })),
      'orderNumber'
    )
)
